import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/segments-dossier`;
const token = localStorage.getItem("token");

/// GET - Tous les segments
export const getAllSegments = async () => {
  try {
    const response = await axios.get(`${apiUrl}/getAll`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des segments:", error);
  }
};

/// GET - Segment par ID
export const getSegmentById = async (segmentId) => {
  try {
    const response = await axios.get(`${apiUrl}/getById/${segmentId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du segment:", error);
  }
};

/// POST - Ajouter un segment
export const addSegment = async (data) => {
  try {
    const response = await axios.post(`${apiUrl}/add`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout du segment:", error);
  }
};

/// PUT - Modifier un segment
export const updateSegment = async (segmentId, data) => {
  try {
    const response = await axios.put(`${apiUrl}/edit/${segmentId}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du segment:", error);
  }
};

/// DELETE - Supprimer un segment
export const deleteSegment = async (segmentId) => {
  try {
    const response = await axios.delete(`${apiUrl}/delete/${segmentId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du segment:", error);
  }
};
